import {Bureau} from './bureau.model';
import {IlotDto} from '../../shared/dto/ilot.dto';

export class Ilot {
	id: number;
	nom: string;
	couleur: string;
	bureaux: Bureau[];

	constructor(ilot: IlotDto, bureaux: Bureau[]) {
		this.id = ilot.id;
		this.nom = ilot.nom;
		this.couleur = ilot.couleur;
		this.bureaux = bureaux;
	}
}
